enum HttpMethod {
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
}

export { HttpMethod }
